import { jsx, jsxs } from "react/jsx-runtime";
import { memo, useCallback } from "react";
import { ActionFooter } from "../../ActionFooter/index.js";
import { Button } from "../../Button/index.js";
import { Drawer } from "../../Drawer/index.js";
import { OverlaySearchHeader, OverlayTitle } from "../../OverlaySearchHeader/index.js";
import { TravelerSelectionContent } from "../TravelerSelectionContent/TravelerSelectionContent.js";
function TravelerSelectionMobile({ ageSelectEnabled, disclaimer, isOpen, handleClose, isHotel, lapInfantLabel, maxAdults, maxChildren, maxRooms, fireMaxRoomsOnClick, maxRoomsMessage, maxRoomsUrl, roomsEnabled, shouldCountLapInfant, state, subLabelMap }) {
    const Footer = useCallback(()=>{
        const handleDoneClick = ()=>{
            state.triggerValidation?.();
            handleClose();
        };
        return /*#__PURE__*/ jsx(ActionFooter, {
            children: /*#__PURE__*/ jsx(Button, {
                type: "primary",
                size: "lg",
                fullWidth: true,
                onClick: handleDoneClick,
                children: "Done"
            })
        });
    }, [
        handleClose,
        state
    ]);
    return /*#__PURE__*/ jsx(Drawer.Root, {
        open: isOpen,
        onOpenChange: (open)=>{
            if (!open) handleClose();
        },
        snapPoints: [
            1
        ],
        children: /*#__PURE__*/ jsxs(Drawer.Portal, {
            children: [
                /*#__PURE__*/ jsx(Drawer.Backdrop, {}),
                /*#__PURE__*/ jsx(Drawer.Viewport, {
                    children: /*#__PURE__*/ jsxs(Drawer.Popup, {
                        height: "full",
                        children: [
                            /*#__PURE__*/ jsx(Drawer.Title, {
                                className: "sr-only",
                                children: "Travelers"
                            }),
                            /*#__PURE__*/ jsx(Drawer.Description, {
                                className: "sr-only",
                                children: "Add your travelers"
                            }),
                            /*#__PURE__*/ jsx(OverlaySearchHeader, {
                                children: /*#__PURE__*/ jsx(OverlayTitle, {
                                    heading: "Travelers",
                                    subHeading: state.label,
                                    handleClose: handleClose
                                })
                            }),
                            /*#__PURE__*/ jsx("div", {
                                className: "relative flex w-full flex-1 overflow-y-auto p-4",
                                children: /*#__PURE__*/ jsx(TravelerSelectionContent, {
                                    ageSelectEnabled: ageSelectEnabled,
                                    disclaimer: disclaimer,
                                    isHotel: isHotel,
                                    lapInfantLabel: lapInfantLabel,
                                    maxAdults: maxAdults,
                                    maxChildren: maxChildren,
                                    maxRooms: maxRooms,
                                    maxRoomsMessage: maxRoomsMessage,
                                    maxRoomsUrl: maxRoomsUrl,
                                    roomsEnabled: roomsEnabled,
                                    shouldCountLapInfant: shouldCountLapInfant,
                                    state: state,
                                    subLabelMap: subLabelMap,
                                    fireMaxRoomsOnClick: fireMaxRoomsOnClick
                                })
                            }),
                            /*#__PURE__*/ jsx("div", {
                                className: "sticky right-0 bottom-0 left-0",
                                children: /*#__PURE__*/ jsx(Footer, {})
                            })
                        ]
                    })
                })
            ]
        })
    });
}
var TravelerSelection_TravelerSelectionMobile = /*#__PURE__*/ memo(TravelerSelectionMobile);
export default TravelerSelection_TravelerSelectionMobile;
